var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddButtonBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.00768C0 4.10036 0 3.1467 0.365292 2.41564C0.700579 1.74462 1.24462 1.20058 1.91564 0.865292C2.6467 0.5 3.60036 0.5 5.50768 0.5L14.4923 0.5C16.3996 0.5 17.3533 0.5 18.0844 0.865292C18.7554 1.20058 19.2994 1.74462 19.6347 2.41564C20 3.1467 20 4.10036 20 6.00768V14.9923C20 16.8996 20 17.8533 19.6347 18.5844C19.2994 19.2554 18.7554 19.7994 18.0844 20.1347C17.3533 20.5 16.3996 20.5 14.4923 20.5L5.50768 20.5C3.60036 20.5 2.6467 20.5 1.91564 20.1347C1.24462 19.7994 0.700579 19.2554 0.365292 18.5844C0 17.8533 0 16.8996 0 14.9923L0 6.00768Z",
    fill: "#3E7EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.05469V15.7769",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13867 10.9219H14.8609",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButtonBlue);
export default __webpack_public_path__ + "static/media/addButtonBlue.84cd966bd6212333bc3a19e8d315a7f4.svg";
export { ForwardRef as ReactComponent };